export default __webpack_public_path__ + "static/media/Solar_Energy_ΗΛ.fe280976.png";